import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<any, any>;

export const DispatchSetLoading: HandlerType = props => {
    props.dispatch({
        type: "Custom/Downloads/SetDownloadLoading",
        isLoading: false,
        isSuccess: true,
    } as any);
};

export const chain = [DispatchSetLoading];

const closeDownloadDocumentToast = createHandlerChainRunner(chain, "CloseDownloadDocumentToast");
export default closeDownloadDocumentToast;
